import Footer from '../../Components/Footer';
import MediaBrowser from '../../Components/Main pages/Media';
import Navbar from '../../Components/Navbar';
import styles from './Videospage.module.css'
import Landingpage from '../Home/Landingpage';
import Button from '../../Components/Button';
import SearchSidebar from '../../Components/Search bars/Treesearch';
// import SearchSidebar from '../../compounds/Search bars/Treesearch';




export default function Videos() {

    return(<>
    <Navbar />
    <Landingpage />
    <div className={styles.main}>
        <div className={styles.container}>
            <div className={styles.section}>
                <span></span>
                <h1>ويديو</h1>
            </div>
            <p>سید حسن نصرالله از روحانیون مبارز و مجاهد معاصر لبنان و دبیر کل جنبش حزب‌الله این کشور بود که سال‌ها در مقابل تجاوزات
                 و جنایات رژیم غاصب صهیونیستی ایستاد و از ملت مظلوم فلسطین دفاع کرد.
                 سید حسن نصرالله در ۳۱ اگوست ۱۹۶۰ میلادی در روستای "البزوریه" در جنوب لبنان به دنیا آمد.
                 او در نوجوانی در سال ۱۹۷۶ به نجف رفت و تحصیلات حوزوی خود را در آنجا آغاز کرد.
                 سید حسن در سال ۱۹۷۸ به لبنان بازگشت و در مدرسه الامام المنتظر (ع)
            </p>
            <Button />
        </div>
    </div>

    <div className={styles.container} >
        <div className={styles.bodyContent}>
            <SearchSidebar />

            <MediaBrowser />
        </div>
    </div>
    <Footer />
    </>);
}